
import { defineComponent } from "vue";
import { RouterView } from "vue-router";

import { site } from "../data/site";
import style from "./style.module.less";
import SubNav from "./sub-nav.vue";

// 模块外壳：独立渲染（App.vue 按 meta.standalone 放行）
// 结构：顶部公司信息条 + 子导航 + 内容区 + 页脚
export default defineComponent({
  name: "XiyouLayout",
  setup() {
    return () => (
      <div class={style.module}>
        <div class={style.topbar}>
          <div class={style.topbarInner}>
            <span>{site.company}</span>
            <span>客服邮箱 {site.supportEmail}</span>
          </div>
        </div>
        <SubNav />
        <div class={style.body}>
          <RouterView />
        </div>
        <footer class={style.footer}>
          <div class={style.footerContent}>
            {site.footerColumns.map((column) => (
              <div class={style.footerItem} key={column.title}>
                <div class={style.footerTitle}>{column.title}</div>
                {column.lines ? (
                  <div class={style.footerText}>
                    {column.lines.map((line) => (
                      <div key={line}>{line}</div>
                    ))}
                  </div>
                ) : null}
                {column.qrcode ? (
                  <div
                    class={style.footerQrcode}
                    style={{ backgroundImage: `url(${site.qrcodeImage})` }}
                  />
                ) : null}
              </div>
            ))}
          </div>
          <div class={style.protocol}>
            {site.agreements.map((item) => (
              <a key={item.text} target="_blank" href={item.href}>
                {item.text}
              </a>
            ))}
          </div>
          <div class={style.copyright}>
            版权所有：{site.copyright}&nbsp;
            <a target="_blank" href="https://beian.miit.gov.cn">
              {site.icp}-{location.hostname === "woshimi.cn" ? "2" : "1"}
            </a>
            <br />
            {site.license}
            <br />
            地址：{site.address}
          </div>
        </footer>
      </div>
    );
  },
});
